import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UserExport } from '@pixacare/domain';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ExportDataHttpService {
  private readonly http = inject(HttpClient);

  getDataExports(): Observable<UserExport[]> {
    return this.http.get<UserExport[]>(`${environment.apiBaseUrl}/export`);
  }

  createNewExport(): Observable<UserExport> {
    return this.http.get<UserExport>(`${environment.apiBaseUrl}/export/requestArchive`);
  }

  delete(exportId: number): Observable<unknown> {
    return this.http.delete(`${environment.apiBaseUrl}/export/${exportId}`);
  }

  getExportLink(exportId: number): Observable<string> {
    return this.http.get(`${environment.apiBaseUrl}/export/${exportId}/link`, { responseType: 'text' });
  }
}
